export const actions = {
  ESTADOS_LOAD_REQUESTED: 'ESTADOS_LOAD_REQUESTED',
  ESTADOS_LOAD_SUCCEEDED: 'ESTADOS_LOAD_SUCCEEDED',
  ESTADOS_LOAD_FILED: 'ESTADOS_LOAD_FILED',

  ESTADOS_MENSAJERIA_LOAD_REQUESTED: 'ESTADOS_MENSAJERIA_LOAD_REQUESTED',
  ESTADOS_MENSAJERIA_LOAD_SUCCEEDED: 'ESTADOS_MENSAJERIA_LOAD_SUCCEEDED',
  ESTADOS_MENSAJERIA_LOAD_FILED: 'ESTADOS_MENSAJERIA_LOAD_FILED',

  ESTADO_UPDATE_REQUESTED: 'ESTADOS_UPDATE_REQUESTED',
  ESTADO_UPDATE_SUCCEEDED: 'ESTADOS_UPDATE_SUCCEEDED',
  ESTADO_UPDATE_FILED: 'ESTADOS_UPDATE_FILED',

  ESTADO_INSERT_REQUESTED: 'ESTADO_INSERT_REQUESTED',
  ESTADO_INSERT_SUCCEEDED: 'ESTADO_INSERT_SUCCEEDED',
  ESTADO_INSERT_FILED: 'ESTADO_INSERT_FILED',

  ESTADO_DELETE_REQUESTED: 'ESTADO_DELETE_REQUESTED',
  ESTADO_DELETE_SUCCEEDED: 'ESTADO_DELETE_SUCCEEDED',
  ESTADO_DELETE_FILED: 'ESTADO_DELETE_FILED',

  ESTADO_MENSAJERIA_UPDATE_REQUESTED: 'ESTADO_MENSAJERIA_UPDATE_REQUESTED',
  ESTADO_MENSAJERIA_UPDATE_SUCCEEDED: 'ESTADO_MENSAJERIA_UPDATE_SUCCEEDED',
  ESTADO_MENSAJERIA_UPDATE_FILED: 'ESTADO_MENSAJERIA_UPDATE_FILED',

  ESTADO_MENSAJERIA_INSERT_REQUESTED: 'ESTADO_MENSAJERIA_INSERT_REQUESTED',
  ESTADO_MENSAJERIA_INSERT_SUCCEEDED: 'ESTADO_MENSAJERIA_INSERT_SUCCEEDED',
  ESTADO_MENSAJERIA_INSERT_FILED: 'ESTADO_MENSAJERIA_INSERT_FILED',

  ESTADO_MENSAJERIA_DELETE_REQUESTED: 'ESTADO_MENSAJERIA_DELETE_REQUESTED',
  ESTADO_MENSAJERIA_DELETE_SUCCEEDED: 'ESTADO_MENSAJERIA_DELETE_SUCCEEDED',
  ESTADO_MENSAJERIA_DELETE_FILED: 'ESTADO_MENSAJERIA_DELETE_FILED',
}

export const getEstadosAction = dispatch => {
  dispatch({
    type: actions.ESTADOS_LOAD_REQUESTED,
  })
}

export const getEstadosMensajeriaAction = dispatch => {
  dispatch({
    type: actions.ESTADOS_MENSAJERIA_LOAD_REQUESTED,
  })
}

export const onSubmitInsertEstadoFormAction = (dispatch, formEstado) => {
  dispatch({
    type: actions.ESTADO_INSERT_REQUESTED,
    payload: formEstado,
  })
}

export const onSubmitUpdateEstadoFormAction = (dispatch, formEstado) => {
  dispatch({
    type: actions.ESTADO_UPDATE_REQUESTED,
    payload: formEstado,
  })
}

export const deleteEstadoAction = (dispatch, id) => {
  dispatch({
    type: actions.ESTADO_DELETE_REQUESTED,
    payload: id,
  })
}

export const onSubmitInsertEstadoMensajeriaFormAction = (dispatch, formEstadoMensajeria) => {
  dispatch({
    type: actions.ESTADO_MENSAJERIA_INSERT_REQUESTED,
    payload: formEstadoMensajeria,
  })
}

export const onSubmitUpdateEstadoMensajeriaFormAction = (dispatch, formEstadoMensajeria) => {
  dispatch({
    type: actions.ESTADO_MENSAJERIA_UPDATE_REQUESTED,
    payload: formEstadoMensajeria,
  })
}

export const deleteEstadoMensajeriaAction = (dispatch, id) => {
  dispatch({
    type: actions.ESTADO_MENSAJERIA_DELETE_REQUESTED,
    payload: id,
  })
}
